<div class="container"
     (mouseover)="mouseOver$.next(true)"
     (mouseout)="mouseOver$.next(false)">
  <ppl-toast *ngFor="let toast of (toasts$ | async)"
             [toast]="toast"
             [containerMouseOver$]="mouseOver$"
             [@slideInOut]
             (close)="onCloseSingle(toast)"></ppl-toast>
</div>
